import { useNavigate } from 'react-router-dom';
import CXOEraLogo from '../shared/CXOEraLogo';

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="ft">
      <div className="ftg">
        <div>
          <CXOEraLogo height={32}/>
          <p className="ftbd">The world's most exclusive C-level executive community. 600+ programs annually across 90 communities, serving 13,000+ global leaders.</p>
          <div style={{display:"flex",gap:16}}>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" style={{
              width:36,height:36,border:"1px solid rgba(201,169,110,.2)",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"rgba(255,255,255,.4)",textDecoration:"none",transition:"all .3s"
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="5"/>
                <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none"/>
              </svg>
            </a>
          </div>
        </div>
        <div><div className="ftct">Programs</div><div className="ftl">{["CIO Community","CISO Community","CHRO Community","CFO Community","CDAO Community"].map(l=><button key={l} className="ftlink" onClick={()=>navigate(`/programs/${l.split(' ')[0].toLowerCase()}`)}>{l}</button>)}</div></div>
        <div>
          <div className="ftct">Company</div>
          <div className="ftl">
            <button className="ftlink" onClick={() => navigate("/about")}>About & Board</button>
            <button className="ftlink" onClick={() => navigate("/about")}>Our Mission</button>
            <button className="ftlink" onClick={() => navigate("/about", { state: { scrollToBoard: true } })}>Leadership</button>
          </div>
        </div>
        <div><div className="ftct">Resources</div><div className="ftl">{["Member Portal","Contact Us","Privacy Policy","Terms"].map(l=><button key={l} className="ftlink">{l}</button>)}</div></div>
      </div>
      <div className="ftb"><CXOEraLogo height={22}/><span>Where Titans Think. Where Eras Begin.™ · © 2026 CXOEra</span></div>
    </footer>
  );
}
